export const SET_CLASS_LIST = 'UNITS/SET_CLASS_LIST'
export const SET_CURRENT_UNIT = 'UNITS/SET_CURRENT_UNIT'
export const SET_CLASS_SCHEDULES_SCHEDULE_LIST = 'UNITS/SET_CLASS_SCHEDULES_SCHEDULE_LIST'
export const SET_SCHEDULES_LIST = 'UNITS/SET_SCHEDULES_LIST'